module.exports = __webpack_public_path__ + "img/cahsback.66edddb4.png";